<div class="p-col-12 p-lg-12">
  <div class="ui-g card">
    <div class="ui-g-12 ui-md-12 ui-lg-12">
      @for (message of msgs; track message) {
        <p-message [life]="3000" [text]="message.detail"></p-message>
      }
      @if (showForm) {
        <form [formGroup]="editPaymentBatchForm" (ngSubmit)="onSubmit()">
          <div class="ui-g">
            <div class="ui-g-12 ui-md-8 ui-lg-6">
              <div class="reqfields">
                <span class="indicate">*</span> required fields
              </div>

              <div class="ui-g form-group">
                <div class="ui-g-12 ui-md-5">Payment Batch Name</div>
                <div class="ui-g-12 ui-md-7">
                  <input
                    type="text"
                    formControlName="paymentBatchName"
                    pInputText
                    readonly />
                </div>
              </div>

              <div class="ui-g form-group">
                <div class="ui-g-12 ui-md-5">
                  Batch Create Date <span class="indicate">*</span>
                </div>
                <div class="ui-g-12 ui-md-7">
                  <p-datepicker
                    formControlName="paymentBatchScheduleDate"
                    [readonlyInput]="true"
                    [iconDisplay]="'input'"
                    [showIcon]="true"></p-datepicker>
                </div>
              </div>

              <div class="ui-g form-group">
                <div class="ui-g-12 ui-md-5">
                  Anticipated Payment Date <span class="indicate">*</span>
                </div>
                <div class="ui-g-12 ui-md-7">
                  <p-datepicker
                    formControlName="anticipatedPaymentDate"
                    [readonlyInput]="true"
                    [iconDisplay]="'input'"
                    [showIcon]="true"></p-datepicker>
                </div>
              </div>

              <div class="ui-g form-group">
                <div class="ui-g-12 ui-md-5">Actual Payment Central Date</div>
                <div class="ui-g-12 ui-md-7">
                  <p-datepicker
                    formControlName="actualPaymentCentralDate"
                    [readonlyInput]="true"
                    [iconDisplay]="'input'"
                    [showIcon]="true"></p-datepicker>
                </div>
              </div>

              <div class="ui-g form-group">
                <div class="ui-g-12 ui-md-5">
                  Payment Batch Status <span class="indicate">*</span>
                </div>
                <div class="ui-g-12 ui-md-7">
                  <p-select
                    [options]="paymentBatchStatus"
                    placeholder="Select"
                    formControlName="paymentBatchStatus"
                    [(ngModel)]="selectedpaymentBatchStatusID"
                    optionLabel="status"></p-select>
                </div>
              </div>

              <div class="ui-g form-group">
                <div class="ui-g-12 ui-md-5">Payment Central RequestID</div>
                <div class="ui-g-12 ui-md-7">
                  <input
                    type="text"
                    formControlName="paymentCentralRequestID"
                    pInputText />
                </div>
              </div>
            </div>
          </div>
          <div class="ui-g">
            <div class="ui-g-12 ui-md-12 ui-lg-12">
              <div class="fl-right">
                <div class="reqfields">
                  <span class="indicate">*</span><b> Note:</b> Export Refreshed
                  in every 5 minutes
                </div>
                <button
                  type="button"
                  pButton
                  [disabled]="!isShowOnlyAssoctd"
                  (click)="onAddNewActivity(false)"
                  class="ui-button-info btnmr"
                  style="padding: 0.5em 1em">
                  <i class="fa fa-plus-circle"></i> Add New Activity
                </button>
                <button
                  type="button"
                  pButton
                  (click)="exportCSV()"
                  class="ui-button-success btnmr"
                  style="padding: 0.5em 1em">
                  <i class="mdl2-excel"></i> Export To CSV
                  @if (isSpin) {
                    <i class="fa fa-spinner fa-spin"></i>
                  }
                </button>
                <button
                  type="button"
                  pButton
                  (click)="downloadExportCSV()"
                  class="ui-button-success btnmr"
                  style="padding: 0.5em 1em">
                  <i class="fa fa-file-archive-o"></i> Export To Zip File
                  @if (isSpinEx) {
                    <i class="fa fa-spinner fa-spin"></i>
                  }
                </button>
              </div>
            </div>
          </div>
          <div class="ui-g bdr">
            @if (loading) {
              <div class="loading-indicator">
                <p-progressSpinner></p-progressSpinner>
              </div>
            }
            <div class="ui-g-12 ui-md-12 ui-lg-12">
              <p-table
                #dt
                [columns]="engcols"
                editMode="row"
                [(selection)]="selectedEngagements"
                dataKey="engagementId"
                [value]="paymentBatchEngagement"
                selectionMode="single"
                [loadingIcon]="loadingIcon"
                [showLoader]="true"
                [scrollable]="true"
                [style]="{ width: '100%' }"
                scrollHeight="800px"
                frozenWidth="275px"
                [paginator]="true"
                [rows]="dataViewRecsPerPage"
                (onPage)="pageChange($event)"
                (onFilter)="applyFilter($event)"
                [pageLinks]="pageLinksPerPage"
                paginatorPosition="top">
                <ng-template pTemplate="caption">
                  <div style="text-align: left">
                    <input
                      type="text"
                      pInputText
                      size="30"
                      placeholder="Search"
                      (input)="
                        dt.filterGlobal($any($event.target).value, 'contains')
                      "
                      style="width: auto"
                      [value]="
                        dt.filters['global']
                          ? $any(dt.filters['global']).value
                          : ''
                      " />
                    <i class="fa fa-search ml-2"></i>
                    <span class="pageInfo visiblelg resettble">{{
                      currentPageInfo
                    }}</span>
                    <span style="float: right"
                      ><a
                        (click)="reset()"
                        (keydown.enter)="reset()"
                        tabindex="0"
                        ><span class="fa fa-repeat"></span> Reset table</a
                      ></span
                    >
                  </div>
                </ng-template>
                <ng-template #header let-columns>
                  <tr>
                    <th class="dashtable colchck" pFrozenColumn>
                      <p-tableHeaderCheckbox
                        [disabled]="editingHeaderCheck"></p-tableHeaderCheckbox>
                    </th>
                    <th class="coleditrow" pFrozenColumn></th>
                    <th
                      [pSortableColumn]="'engagementID'"
                      class="colsmall"
                      pFrozenColumn>
                      Engagement ID<p-sortIcon
                        [field]="'engagementID'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'engagementName'" class="colmedium">
                      Incentive Name<p-sortIcon
                        [field]="'engagementName'"></p-sortIcon>
                    </th>
                    <th
                      [pSortableColumn]="'engagementSubType'"
                      class="colsmall">
                      Sub Type<p-sortIcon
                        [field]="'engagementSubType'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'Original Program'" class="colsmall">
                      Original Program<p-sortIcon
                        [field]="'program'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'partnerName'" class="colsmall">
                      Partner Name<p-sortIcon
                        [field]="'partnerName'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'tier'" class="colsmall">
                      Milestone 2 Tier<p-sortIcon [field]="'tier'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'fundingAmount'" class="colsmall">
                      Funding Amount<p-sortIcon
                        [field]="'fundingAmount'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'partnerLocation'" class="colsmall">
                      Partner Location<p-sortIcon
                        [field]="'partnerLocation'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'fiscalYear'" class="colsmall">
                      Fiscal Year<p-sortIcon
                        [field]="'fiscalYear'"></p-sortIcon>
                    </th>
                    <th
                      [pSortableColumn]="'paymentProfileStatus'"
                      class="colsmall">
                      ProfileStatus<p-sortIcon
                        [field]="'paymentProfileStatus'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'partnerPriority'" class="colsmall">
                      Partner Priority<p-sortIcon
                        [field]="'partnerPriority'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'blockedStatus'" class="colsmall">
                      Blocked Status<p-sortIcon
                        [field]="'blockedStatus'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'partnerId'" class="colsmall">
                      Partner ID<p-sortIcon [field]="'partnerId'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'payeeName'" class="colsmall">
                      Payee Name<p-sortIcon [field]="'payeeName'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'contactName'" class="colsmall">
                      Contact Name<p-sortIcon
                        [field]="'contactName'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'contactEmail'" class="colsmall">
                      Contact Email<p-sortIcon
                        [field]="'contactEmail'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'emailLanguage'" class="colsmall">
                      Email Language<p-sortIcon
                        [field]="'emailLanguage'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'accountCode'" class="colsmall">
                      Account Code<p-sortIcon
                        [field]="'accountCode'"></p-sortIcon>
                    </th>
                    <th
                      [pSortableColumn]="'internalOrderOrCostCenter'"
                      class="colsmall">
                      Internal Order or<br />Cost Center<p-sortIcon
                        [field]="'internalOrderOrCostCenter'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'currency'" class="colxsmall">
                      Currency<p-sortIcon [field]="'currency'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'amount'" class="colxsmall">
                      Amount<p-sortIcon [field]="'amount'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'netAmount'" class="colxsmall">
                      Net Amount<p-sortIcon [field]="'netAmount'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'taxAmount'" class="colxsmall">
                      Tax Amount<p-sortIcon [field]="'taxAmount'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'msInvoiceNumber'" class="colmedium">
                      MS Invoice Number<p-sortIcon
                        [field]="'msInvoiceNumber'"></p-sortIcon>
                    </th>
                    <th
                      [pSortableColumn]="'msInvoicePaidDate'"
                      class="colmedium">
                      MS Invoice Paid Date<p-sortIcon
                        [field]="'msInvoicePaidDate'"></p-sortIcon>
                    </th>
                    <th
                      [pSortableColumn]="'paymentCentralTransactionID'"
                      class="colmedium">
                      Payment Central<br />Transaction ID<p-sortIcon
                        [field]="'paymentCentralTransactionID'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'payoutMetric'" class="colmedium">
                      Payout Metric<p-sortIcon
                        [field]="'payoutMetric'"></p-sortIcon>
                    </th>
                  </tr>
                  <ng-template>
                    <tr>
                      <th class="colchck" pFrozenColumn></th>
                      <th class="coleditrow" pFrozenColumn></th>
                      <th class="dashtable colsmall" pFrozenColumn>
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'engagementID',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['engagementID']
                              ? $any(dt.filters['engagementID']).value
                              : ''
                          " />
                      </th>
                      <th class="dashtable colmedium">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'engagementName',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['engagementName']
                              ? $any(dt.filters['engagementName']).value
                              : ''
                          " />
                      </th>
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'engagementSubType',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['engagementSubType']
                              ? $any(dt.filters['engagementSubType']).value
                              : ''
                          " />
                      </th>
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'program',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['program']
                              ? $any(dt.filters['program']).value
                              : ''
                          " />
                      </th>

                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'partnerName',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['partnerName']
                              ? $any(dt.filters['partnerName']).value
                              : ''
                          " />
                      </th>
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'tier',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['tier']
                              ? $any(dt.filters['tier']).value
                              : ''
                          " />
                      </th>
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'fundingAmount',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['fundingAmount']
                              ? $any(dt.filters['fundingAmount']).value
                              : ''
                          " />
                      </th>
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'partnerLocation',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['partnerLocation']
                              ? $any(dt.filters['partnerLocation']).value
                              : ''
                          " />
                      </th>
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'fiscalYear',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['fiscalYear']
                              ? $any(dt.filters['fiscalYear']).value
                              : ''
                          " />
                      </th>
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'paymentProfileStatus',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['paymentProfileStatus']
                              ? $any(dt.filters['paymentProfileStatus']).value
                              : ''
                          " />
                      </th>

                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'partnerPriority',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['partnerPriority']
                              ? $any(dt.filters['partnerPriority']).value
                              : ''
                          " />
                      </th>
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'blockedStatus',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['blockedStatus']
                              ? $any(dt.filters['blockedStatus']).value
                              : ''
                          " />
                      </th>
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'partnerId',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['partnerId']
                              ? $any(dt.filters['partnerId']).value
                              : ''
                          " />
                      </th>
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'payeeName',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['payeeName']
                              ? $any(dt.filters['payeeName']).value
                              : ''
                          " />
                      </th>
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'contactName',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['contactName']
                              ? $any(dt.filters['contactName']).value
                              : ''
                          " />
                      </th>
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'contactEmail',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['contactEmail']
                              ? $any(dt.filters['contactEmail']).value
                              : ''
                          " />
                      </th>
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'emailLanguage',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['emailLanguage']
                              ? $any(dt.filters['emailLanguage']).value
                              : ''
                          " />
                      </th>
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'accountCode',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['accountCode']
                              ? $any(dt.filters['accountCode']).value
                              : ''
                          " />
                      </th>
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'internalOrderOrCostCenter',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['internalOrderOrCostCenter']
                              ? $any(dt.filters['internalOrderOrCostCenter'])
                                  .value
                              : ''
                          " />
                      </th>
                      <th class="dashtable colxsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'currency',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['currency']
                              ? $any(dt.filters['currency']).value
                              : ''
                          " />
                      </th>
                      <th class="dashtable colxsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'amount',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['amount']
                              ? $any(dt.filters['amount']).value
                              : ''
                          " />
                      </th>
                      <th class="dashtable colxsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'netAmount',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['netAmount']
                              ? $any(dt.filters['netAmount']).value
                              : ''
                          " />
                      </th>
                      <th class="dashtable colxsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'taxAmount',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['taxAmount']
                              ? $any(dt.filters['taxAmount']).value
                              : ''
                          " />
                      </th>
                      <th class="dashtable colmedium">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'msInvoiceNumber',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['msInvoiceNumber']
                              ? $any(dt.filters['msInvoiceNumber']).value
                              : ''
                          " />
                      </th>
                      <th class="dashtable colmedium">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'msInvoicePaidDate',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['msInvoicePaidDate']
                              ? $any(dt.filters['msInvoicePaidDate']).value
                              : ''
                          " />
                      </th>
                      <th class="dashtable colmedium">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'paymentCentralTransactionID',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['paymentCentralTransactionID']
                              ? $any(dt.filters['paymentCentralTransactionID'])
                                  .value
                              : ''
                          " />
                      </th>
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'payoutMetric',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['payoutMetric']
                              ? $any(dt.filters['payoutMetric']).value
                              : ''
                          " />
                      </th>
                    </tr>
                  </ng-template>
                </ng-template>
                <ng-template
                  #body
                  let-rowData
                  let-editing="editing"
                  let-columns="columns"
                  let-ri="rowIndex">
                  <tr [pEditableRow]="rowData" class="wa-uneven-height-fix">
                    <td class="colmedium" pFrozenColumn>
                      <p-checkbox
                        name="chcklist"
                        [disabled]="editing"
                        inputId="eng_chk_{{ rowData.engagementId }}"
                        [value]="rowData"
                        formControlName="selectedEngs"
                        (onChange)="selectRow($event, rowData)"
                        [(ngModel)]="selectedEngagements"></p-checkbox>
                    </td>
                    <td class="dashtable coleditrow" pFrozenColumn>
                      <div
                        *ngIf="rowData.editCheckBox === true"
                        [style]="{
                          display: 'flex'
                        }">
                        <!-- eslint-disable @angular-eslint/template/elements-content -->
                        <button
                          *ngIf="!editing"
                          pButton
                          [style]="{
                            paddingBlock: '0px !important',
                            width: '22px',
                            height: '22px'
                          }"
                          type="button"
                          pInitEditableRow
                          icon="fa fa-pencil"
                          class="ui-button-info btnmr"
                          (click)="onRowEditInit(rowData)"></button>
                        <button
                          *ngIf="editing"
                          pButton
                          type="button"
                          [style]="{
                            paddingBlock: '0px !important',
                            width: '22px',
                            height: '22px',
                            backgroundColor: 'green'
                          }"
                          pSaveEditableRow
                          icon="pi pi-check"
                          class="ui-button-success"
                          style="margin-right: 0.5em"
                          (click)="onRowEditSave(rowData)"></button>
                        <button
                          *ngIf="editing"
                          pButton
                          type="button"
                          [style]="{
                            paddingBlock: '0px !important',
                            width: '22px',
                            height: '22px',
                            backgroundColor: 'red'
                          }"
                          pCancelEditableRow
                          icon="pi pi-times"
                          class="ui-button-danger"
                          (click)="onRowEditCancel(rowData, ri)"></button>
                      </div>
                    </td>
                    <td class="colsmall" pFrozenColumn>
                      {{ rowData.engagementId }}
                    </td>
                    <td class="colmedium">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.engagementName }}"
                        >{{ rowData.engagementName }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.engagementSubType }}"
                        >{{ rowData.engagementSubType }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.program }}"
                        >{{ rowData.program }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.partnerName }}"
                        >{{ rowData.partnerName }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.tier }}"
                        >{{ rowData.tier }}</span
                      >
                    </td>

                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.fundingAmount }}"
                        >{{ rowData.fundingAmount }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.partnerLocation }}"
                        >{{ rowData.partnerLocation }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.fiscalYear }}"
                        >{{ rowData.fiscalYear }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.paymentProfileStatus }}"
                        >{{ rowData.paymentProfileStatus }}</span
                      >
                    </td>

                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.partnerPriority }}"
                        >{{ rowData.partnerPriority }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.blockedStatus }}"
                        >{{ rowData.blockedStatus }}</span
                      >
                    </td>

                    <td class="dashtable colsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.partnerId"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          {{ rowData.partnerId }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.payeeName"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          <span
                            tooltipPosition="top"
                            pTooltip="{{ rowData.payeeName }}"
                            >{{ rowData.payeeName }}</span
                          >
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.contactName"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          <span
                            tooltipPosition="top"
                            pTooltip="{{ rowData.contactName }}"
                            >{{ rowData.contactName }}</span
                          >
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.contactEmail"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          <span
                            tooltipPosition="top"
                            pTooltip="{{ rowData.contactEmail }}"
                            >{{ rowData.contactEmail }}</span
                          >
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.emailLanguage"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          <span
                            tooltipPosition="top"
                            pTooltip="{{ rowData.emailLanguage }}"
                            >{{ rowData.emailLanguage }}</span
                          >
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.accountCode"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          <span
                            tooltipPosition="top"
                            pTooltip="{{ rowData.accountCode }}"
                            >{{ rowData.accountCode }}</span
                          >
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="
                              firstEditInitEng.internalOrderOrCostCenter
                            "
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          <span
                            tooltipPosition="top"
                            pTooltip="{{ rowData.internalOrderOrCostCenter }}"
                            >{{ rowData.internalOrderOrCostCenter }}</span
                          >
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colxsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.currency"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          <span
                            tooltipPosition="top"
                            pTooltip="{{ rowData.currency }}"
                            >{{ rowData.currency }}</span
                          >
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colxsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.amount"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          {{ rowData.amount }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colxsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.netAmount"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          {{ rowData.netAmount }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colxsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.taxAmount"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          {{ rowData.taxAmount }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colmedium">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.msInvoiceNumber"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          @if (
                            rowData.msInvoiceNumber !== null &&
                            rowData.msInvoiceNumber !== ''
                          ) {
                            <span
                              tooltipPosition="top"
                              pTooltip="{{ rowData.msInvoiceNumber }}"
                              >{{ rowData.msInvoiceNumber }}</span
                            >
                          }
                          @if (
                            rowData.msInvoiceNumber === null ||
                            rowData.msInvoiceNumber === ''
                          ) {
                            <span tooltipPosition="top">Missing</span>
                          }
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colcalendar">
                      <p-cellEditor>
                        <ng-template #input>
                          <p-datepicker
                            dataType="date"
                            dateFormat="dd/mm/yy"
                            [(ngModel)]="firstEditInitEng.msInvoicePaidDate"
                            [ngModelOptions]="{ standalone: true }"
                            [iconDisplay]="'input'"
                            [showIcon]="true"></p-datepicker>
                        </ng-template>
                        <ng-template #output>
                          @if (rowData.msInvoicePaidDate !== null) {
                            <span
                              tooltipPosition="top"
                              pTooltip="{{
                                rowData.msInvoicePaidDate | date: 'MM/dd/yyyy'
                              }}"
                              >{{
                                rowData.msInvoicePaidDate | date: 'MM/dd/yyyy'
                              }}</span
                            >
                          }
                          @if (rowData.msInvoicePaidDate === null) {
                            <span>Missing</span>
                          }
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colmedium">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="
                              firstEditInitEng.paymentCentralTransactionID
                            "
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          @if (
                            rowData.paymentCentralTransactionID !== null &&
                            rowData.paymentCentralTransactionID !== ''
                          ) {
                            <span
                              tooltipPosition="top"
                              pTooltip="{{
                                rowData.paymentCentralTransactionID
                              }}"
                              >{{ rowData.paymentCentralTransactionID }}</span
                            >
                          }
                          @if (
                            rowData.paymentCentralTransactionID === null ||
                            rowData.paymentCentralTransactionID === ''
                          ) {
                            <span tooltipPosition="top">Missing</span>
                          }
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.payoutMetric }}"
                        >{{ rowData.payoutMetric }}</span
                      >
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
          @for (message of msgs; track message) {
            <p-message [life]="3000" [text]="message.detail"></p-message>
          }
          <div class="ui-g">
            <div class="ui-g-12 ui-md-12 ui-lg-12 mar10">
              <button
                type="submit"
                pButton
                [disabled]="!editPaymentBatchForm.valid || this.disableSubmit"
                class="flat btnmr">
                Submit
              </button>
              <button
                type="button"
                pButton
                (click)="cancelSearchNav()"
                class="ui-button-secondary flat">
                Cancel
              </button>
            </div>
          </div>
        </form>
      }
    </div>
  </div>
</div>
